import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2mvnb3r8r: FaireProductEntity = {
  token: "p_x2mvnb3r8r",
  type: "product",
  name: "woodland watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/0ac197c1f571df4fa6bcac32e06c38b42b091bec8558cf4d918979df1e4bdaf1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac3458935fe358dfef2f512c5a1c8c920bd78ba3d77d00fa576c4e9ac3d87008.jpeg",
    "https://cdn.faire.com/fastly/f4b43a2e7d803d6d8ac1a2b0e30261e70fd558c6309e2ff53973f84679dff856.jpeg",
    "https://cdn.faire.com/fastly/1e582d874d8a30092704335f401e532b9c324375afa9141a4d7fc88e9f42535f.jpeg",
    "https://cdn.faire.com/fastly/3a3d6a83cb3ce8f982dcb02bc52487613758154b0f5927963a04f0881abdc411.jpeg",
    "https://cdn.faire.com/fastly/57df057c56ff4a0fb0e492e5cae29e09e77397b528432c3fa519450117c5c611.jpeg",
    "https://cdn.faire.com/fastly/4638d911f02f8a9a9af20028c56e85b7825f714c4097f63a5cc86546222aa84f.jpeg",
    "https://cdn.faire.com/fastly/aa032de433e9f95c71dae37def5b599a2c357b83a8318968587f073bd0a6fe96.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve woodland illustrations — a bear, fox, fawn, hedgehog, owl, mushrooms, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA bestselling title with broad appeal. Performs strongly across gift, home, and nature-focused boutiques year-round.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:08.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
